import { IActionsMenuParams } from '@components/core/actions-menu/actions-menu.interface';

// Only TrialOS admins can manage TrialOS study membership
export const buildTrialOsStudyMembershipAction = ({
    isTrialOsAdmin,
    enabled,
    onClick,
}: {
    isTrialOsAdmin: boolean;
    enabled: boolean;
    onClick: () => void;
}): IActionsMenuParams[] =>
    isTrialOsAdmin ? [{ label: 'uam:trialOsStudyMembership', icon: ['fal', 'link'], onClick, enabled }] : [];
